export default {"src":"/_next/static/media/impactangels.21ecb83e.svg","height":484,"width":1799,"blurWidth":0,"blurHeight":0};